import * as React from 'react';

function CartError(props) {
	return (
		<svg
			aria-label={`cart error icon`}
			width={'55'}
			height={'40'}
			viewBox={'0 0 55 40'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>cart error icon</title>
			<path d={'M16.1816 29.0221H42.1632L45.1727 20'} stroke={'#1F1F1F'} strokeWidth={'2'} strokeMiterlimit={'10'} />
			<path d={'M10.2773 9.48706H33.3113'} stroke={'#1F1F1F'} strokeWidth={'2'} />
			<path d={'M18.3539 38.4617L8.28711 1.53857'} stroke={'#1F1F1F'} strokeWidth={'2'} strokeMiterlimit={'10'} />
			<path d={'M0.140625 2.79028H9.30134'} stroke={'#1F1F1F'} strokeWidth={'2'} strokeMiterlimit={'10'} />
			<path d={'M17.0645 37.3818L39.0509 37.3818'} stroke={'#1F1F1F'} strokeWidth={'2'} strokeMiterlimit={'10'} />
			<path d={'M52.2974 10.9649C52.2974 16.2533 47.9973 20.5453 42.6868 20.5453C37.3763 20.5453 33.0762 16.2533 33.0762 10.9649C33.0762 5.6765 37.3763 1.38452 42.6868 1.38452C47.9973 1.38452 52.2974 5.6765 52.2974 10.9649Z'} stroke={'black'} strokeWidth={'2'} />
			<path d={'M37.9258 15.7708L47.8913 5.83358'} stroke={'#1F1F1F'} strokeWidth={'1.5'} />
			<path d={'M37.9258 5.83423L47.8913 15.7714'} stroke={'#1F1F1F'} strokeWidth={'1.5'} />
		</svg>
	);
}

export default CartError;
